/**
 * Komissiya maydoni (2026-10-25) -- hamma pul formasida bir xil: foiz (kategoriyadan qo'yiladi, o'zgartirsa bo'ladi) va ostida
 * natija: "Komissiya 20,000 · hisobga 980,000". Hisob-kitob `commission.ts` da, aniq summa serverda.
 */
import { useTranslation } from "react-i18next";
import { Field, NumberInput } from "@/components/ui/field";
import { pctError, withCommission } from "./commission";
import { fmt } from "./money";
import type { Currency, Direction } from "./types";

export function CommissionField({
  direction,
  amount,
  currency,
  value,
  onChange,
  error,
}: {
  direction: Direction;
  /** Asosiy summa (komissiyadan oldin), `currency` da */
  amount: number;
  currency: Currency;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}) {
  const { t } = useTranslation("budget");
  const bad = pctError(value);
  const { net, fee } = withCommission(direction, amount, value);
  const hint = fee > 0 ? t(direction === "in" ? "commission.resultIn" : "commission.resultOut", { fee: fmt(fee, currency), net: fmt(net, currency) }) : t("commission.hint");
  return (
    <Field label={t("commission.label")} error={error || (bad ? t("commission.invalid") : undefined)} hint={hint}>
      <NumberInput decimals={2} min={0} value={value} onChange={(e) => onChange(e.target.value)} placeholder="0" className="max-w-[140px]" aria-invalid={bad || undefined} />
    </Field>
  );
}
